import { render, staticRenderFns } from "./Myccorder.vue?vue&type=template&id=5cd2e02c&scoped=true&"
import script from "./Myccorder.vue?vue&type=script&lang=js&"
export * from "./Myccorder.vue?vue&type=script&lang=js&"
import style0 from "./Myccorder.vue?vue&type=style&index=0&id=5cd2e02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd2e02c",
  null
  
)

export default component.exports